import { authHeader } from './auth.services';
import { apiServer } from '../globalVars';
import { userService } from './user.service';

export const reclamacionService = {
  getReclamaciones,
  getReclamacion,
  cambiarEstado,
  marcarLeida,
  addComment,
  getAlbaranUltimos,
  enviarReclamacion
};

function enviarReclamacion(body) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(body)
  };
  return fetch(`${apiServer}/reclamacion/cliente/`, requestOptions);
}

function getReclamacion(reclamacionId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };
  return fetch(`${apiServer}/reclamacion/${reclamacionId}`, requestOptions)
    .then(handleResponse)
    .then(reclamacion => {
      return reclamacion;
    });
}

function getAlbaranUltimos(clientId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };
  return fetch(
    `${apiServer}/cliente/${clientId}/albaran/ultimos`,
    requestOptions
  )
    .then(response => response.json())
    .then(data => {
      return data;
    });
}

function marcarLeida(issue) {
  if (issue.status == "Nueva") {
    return cambiarEstado(issue, "Leída");
  }
  return Promise.resolve(issue);
}

function addComment(issue, comment) {
  let endpoint_url = `${apiServer}/reclamacion/${issue.category.toLowerCase()}/${issue._id}/comment`;
  return fetch(endpoint_url, {
    method: "PUT",
    headers: authHeader(),
    body: JSON.stringify({ comment: comment })
  }).then(handleResponse)
    .then(reclamacion => {
      return reclamacion;
    });
}

function cambiarEstado(issue, estado) {
  issue.status = estado;
  let endpoint_url = `${apiServer}/reclamacion/${issue.category.toLowerCase()}/${issue._id}/status`;
  return fetch(endpoint_url, {
    method: "PUT",
    headers: authHeader(),
    body: JSON.stringify({ status: estado }),
  }).then(handleResponse)
    .then(reclamacion => {
      return reclamacion;
    });
}

function getReclamaciones(search) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };
  let url_path = `${apiServer}/reclamacion/summary?rows=${search.pagination.perPage};page=${search.pagination.currentPage}`;

  if (search.sort != null) {
    url_path += `;sort=${search.sort};direction=${search.sortOrder}`;
  }
  if (search.text != null) {
    url_path += ";search=" + search.text;
  }
  if (search.estados != null && search.estados.length > 0) {
    url_path += ";estados=" + search.estados.toString();
  }
  if (search.tipos != null && search.tipos.length > 0) {
    url_path += ";tipos=" + search.tipos.toString();
  }
  if (search.categorias != null && search.categorias.length > 0) {
    url_path += ";categorias=" + search.categorias.toString();
  }

  return fetch(url_path, requestOptions)
    .then(handleResponse)
    .then(reclamaciones => {
      return reclamaciones;
    });
}
function handleResponse(response) {
  return response.text().then(text => {
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        userService.logout();
        location.reload(true);
      }
      const data = text && JSON.parse(text);
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    } else {
      return text && JSON.parse(text);
    }
  });
}